// https://theme-ui.com/theming
// https://theme-ui.com/theme-spec

const colors = {
  text: "#323232",
  background: "#F6FCFF",
  primary: "#327AC6",
  green: "#20B18B",
  yellow: "#FFDD57",
  red: "#FF3860",
  darkBlue: "#01356D",
  white: "#FFF",
  black: "#222222",
  border: "#86B8D8",
  muted: "#757575",
  tableHover: "#E1F2FC",
};

const fonts = {
  body:
    '"Open Sans", -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif',
  heading:
    '"Open Sans", -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif',
  monospace: "monospace",
};

const fontWeights = {
  body: 400,
  heading: 700,
  light: 300,
  normal: 400,
  medium: 600,
  semibold: 600,
  bold: 700,
};

const lineHeights = {
  body: 1.5,
  heading: 1.125,
};

//    Index:         0    1     2     3    4    5   6   7   8  9
//    Sizes:        12,   14,  16,   20,  24,  28, 32, 40, 48 64
const fontSizes = [0.75, 0.875, 1, 1.25, 1.5, 1.75, 2, 2.5, 3, 4].map(
  n => `${n}rem`,
);

//    Index:   0   1     2   3    4   5   6   7   8   9
//    Sizes:   0,  4,    8,  12,  16, 24, 32, 40, 48, 64
const space = [0, 0.25, 0.5, 0.75, 1, 1.5, 2, 2.5, 3, 4].map(n => `${n}rem`);

const breakpoints = [
  30, // 480px
  48, // 768px
  62, // 992px
  80, // 1280px
].map(n => `${n}em`);

const radii = {
  none: "0",
  sm: "0.125rem",
  default: "0.25rem",
  lg: "0.5rem",
  full: "9999px",
};

const zIndices = {
  hide: -1,
  auto: "auto",
  base: 0,
  overlay: 1000,
  drawer: 1100,
  popover: 1200,
};

const styles = {};

export interface StyledTheme {
  colors: { [key in keyof typeof colors]: string };
  fonts: { [key in keyof typeof fonts]: string };
  fontWeights: { [key in keyof typeof fontWeights]: number };
  fontSizes: typeof fontSizes;
  space: typeof space;
  breakpoints: typeof breakpoints;
  radii: { [key in keyof typeof radii]: string };
  zIndices: { [key in keyof typeof zIndices]: string | number };
  [key: string]: any;
}

export const theme: StyledTheme = {
  colors,
  fonts,
  lineHeights,
  fontSizes,
  fontWeights,
  space,
  breakpoints,
  radii,
  zIndices,
  styles,
};
